var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"field-name-label",style:(_setup.positionStyle)},[_vm._v(_vm._s(_setup.props.fieldName))])
}
var staticRenderFns = []

export { render, staticRenderFns }